<div class="credit-card" [class]="statusClass">
  <div class="card-header">
    <div class="header-info">
      <i class="pi pi-list"></i>
      <h3>Historial de Créditos</h3>
    </div>
    <div class="completion-indicator">
      <span class="percentage">{{ completionPercentage }}%</span>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="completionPercentage"></div>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div *ngIf="!hasData" class="no-data">
      <i class="pi pi-list"></i>
      <p>No hay créditos registrados</p>
    </div>

    <div *ngIf="hasData" class="data-sections">
      <!-- Resumen General -->
      <div class="section">
        <h4 class="section-title">Resumen General</h4>
        <div class="credits-overview">
          <div class="overview-cards">
            <div class="overview-card total">
              <div class="card-icon">
                <i class="pi pi-list"></i>
              </div>
              <div class="card-content-overview">
                <div class="label">Total de Créditos</div>
                <div class="value">{{ totalCredits }}</div>
              </div>
            </div>

            <div class="overview-card active">
              <div class="card-icon">
                <i class="pi pi-check-circle"></i>
              </div>
              <div class="card-content-overview">
                <div class="label">Créditos Activos</div>
                <div class="value">{{ activeCredits }}</div>
              </div>
            </div>

            <div class="overview-card outstanding">
              <div class="card-icon">
                <i class="pi pi-wallet"></i>
              </div>
              <div class="card-content-overview">
                <div class="label">Saldo Total</div>
                <div class="value">{{ formatCurrency(totalOutstandingBalance) }}</div>
              </div>
            </div>
          </div>

          <!-- Indicador de Salud Crediticia -->
          <div class="credit-health" [class]="'health-' + creditHealthStatus">
            <div class="health-header">
              <i class="pi" [class]="creditHealthStatus === 'excellent' ? 'pi-check' : 
                                   creditHealthStatus === 'good' ? 'pi-thumbs-up' : 
                                   creditHealthStatus === 'fair' ? 'pi-exclamation-triangle' : 'pi-times'"></i>
              <span class="health-label">Salud Crediticia: 
                <strong>{{ creditHealthStatus === 'excellent' ? 'Excelente' : 
                           creditHealthStatus === 'good' ? 'Buena' : 
                           creditHealthStatus === 'fair' ? 'Regular' : 'Deficiente' }}</strong>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Lista de Créditos -->
      <div class="section">
        <h4 class="section-title">Detalle de Créditos</h4>
        <div class="credits-list">
          <div class="credit-item" 
               *ngFor="let credit of data; let i = index; trackBy: trackByIndex"
               [class]="getCreditStatusClass(credit)">
            <div class="credit-header">
              <div class="credit-title">
                <span class="contract-number">{{ credit.contractNumber || 'Sin número' }}</span>
                <span class="credit-type">{{ getCreditTypeDisplay(credit.creditType) }}</span>
              </div>
              <div class="credit-status" [class]="getCreditStatusClass(credit)">
                {{ getCreditStatusDisplay(credit) }}
              </div>
            </div>

            <div class="credit-body">
              <div class="credit-financial">
                <div class="financial-item" *ngIf="credit.initialBalance !== undefined">
                  <label>Monto Original:</label>
                  <span class="value">{{ formatCurrency(credit.initialBalance) }}</span>
                </div>

                <div class="financial-item" *ngIf="credit.outstandingBalance !== undefined">
                  <label>Saldo Actual:</label>
                  <span class="value" 
                        [class]="credit.outstandingBalance > 0 ? 'balance-positive' : 'balance-zero'">
                    {{ formatCurrency(credit.outstandingBalance) }}
                  </span>
                </div>

                <div class="financial-item" *ngIf="credit.paymentAmount !== undefined">
                  <label>Pago {{ getPaymentFrequencyDisplay(credit.paymentFrequency) }}:</label>
                  <span class="value">{{ formatCurrency(credit.paymentAmount) }}</span>
                </div>

                <div class="financial-item" *ngIf="credit.termMonths !== undefined">
                  <label>Plazo:</label>
                  <span class="value">{{ credit.termMonths }} meses</span>
                </div>
              </div>

              <div class="credit-dates">
                <div class="date-item" *ngIf="credit.openingDate">
                  <label>Apertura:</label>
                  <span class="value">{{ formatDate(credit.openingDate) }}</span>
                </div>

                <div class="date-item" *ngIf="credit.lastPaymentDate">
                  <label>Último Pago:</label>
                  <span class="value">{{ formatDate(credit.lastPaymentDate) }}</span>
                </div>

                <div class="date-item warning" *ngIf="credit.firstDefaultDate">
                  <label>Primer Incumplimiento:</label>
                  <span class="value">{{ formatDate(credit.firstDefaultDate) }}</span>
                </div>

                <div class="date-item success" *ngIf="credit.settlementDate">
                  <label>Liquidación:</label>
                  <span class="value">{{ formatDate(credit.settlementDate) }}</span>
                </div>
              </div>

              <!-- Experiencias Crediticias -->
              <div class="credit-experiences" *ngIf="credit.creditExperiences">
                <label>Experiencias Crediticias:</label>
                <div class="experiences-display">{{ credit.creditExperiences }}</div>
              </div>

              <!-- Información Adicional Colapsable -->
              <div class="credit-additional" *ngIf="hasAdditionalInfo(credit)">
                <button class="toggle-details" 
                        (click)="toggleCreditDetails(i)"
                        [class.expanded]="isExpanded(i)">
                  <i class="pi" [class]="isExpanded(i) ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                  Detalles adicionales
                </button>
                
                <div class="additional-content" [class.expanded]="isExpanded(i)">
                  <div class="additional-grid">
                    <div class="additional-item" *ngIf="credit.maxCreditUsed !== undefined">
                      <label>Crédito Máximo Utilizado:</label>
                      <span class="value">{{ formatCurrency(credit.maxCreditUsed) }}</span>
                    </div>

                    <div class="additional-item" *ngIf="credit.restructuringDate">
                      <label>Fecha de Reestructura:</label>
                      <span class="value">{{ formatDate(credit.restructuringDate) }}</span>
                    </div>

                    <div class="additional-item" *ngIf="credit.observationKey">
                      <label>Clave de Observación:</label>
                      <span class="value">{{ credit.observationKey }}</span>
                    </div>

                    <div class="additional-item" *ngIf="credit.currency">
                      <label>Moneda:</label>
                      <span class="value">{{ credit.currency }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
